<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách ngành nghề</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">Dashboard</a></li>
              <li class="breadcrumb-item active">Ngành nghề</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_industry_modal">
              <i class="fa fa-plus"></i> Thêm ngành nghề
            </a>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped custom-table mb-0 datatable">
            <thead>
              <tr>
                <th>Tên ngành nghề</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="industry in industries" :key="industry.id">
                <td>{{ industry.name }}</td>
                <td class="text-right">
                  <div class="dropdown dropdown-action">
                    <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown">
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#edit_industry_modal"
                        @click="editIndustry(industry)"
                      >
                        <i class="fa fa-pencil m-r-5"></i> Sửa
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        data-toggle="modal"
                        data-target="#delete_industry_modal"
                        @click="confirmDelete(industry.id)"
                      >
                        <i class="fa fa-trash-o m-r-5"></i> Xóa
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="industries.length === 0 && !loading">
                <td colspan="2" class="text-center">Không có ngành nghề nào.</td>
              </tr>
              <tr v-if="loading">
                <td colspan="2" class="text-center">Đang tải...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-3">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info">
            Hiển thị {{ currentPage * pageSize + 1 }} đến
            {{ Math.min((currentPage + 1) * pageSize, totalElements) }} của {{ totalElements }} mục
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <ul class="pagination">
            <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 0 }">
              <a href="#" class="page-link" @click.prevent="goToPage(currentPage - 1)">Previous</a>
            </li>
            <li
              v-for="pageNum in totalPages"
              :key="pageNum"
              class="paginate_button page-item"
              :class="{ active: pageNum === currentPage + 1 }"
            >
              <a href="#" class="page-link" @click.prevent="goToPage(pageNum - 1)">{{ pageNum }}</a>
            </li>
            <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages - 1 }">
              <a href="#" class="page-link" @click.prevent="goToPage(currentPage + 1)">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal thêm -->
    <div id="add_industry_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="addIndustry">
            <div class="modal-header">
              <h5 class="modal-title">Thêm ngành nghề</h5>
              <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Tên ngành nghề<span class="text-danger">*</span></label>
                <input v-model="newIndustry.name" class="form-control" required />
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Thêm</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal sửa -->
    <div id="edit_industry_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="updateIndustry">
            <div class="modal-header">
              <h5 class="modal-title">Sửa ngành nghề</h5>
              <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Tên ngành nghề<span class="text-danger">*</span></label>
                <input v-model="currentIndustry.name" class="form-control" required />
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal xóa -->
    <div id="delete_industry_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h3>Bạn có chắc muốn xóa ngành nghề này?</h3>
            <div class="mt-3">
              <button class="btn btn-danger mr-2" @click="deleteIndustry">Xóa</button>
              <button class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import api from '../api';
import { useToast } from 'vue-toastification';

const toast = useToast();
const industries = ref([]);
const loading = ref(true);

const newIndustry = reactive({ name: '' });
const currentIndustry = reactive({ id: null, name: '' });
const industryToDeleteId = ref(null);

const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

const fetchIndustries = async () => {
  loading.value = true;
  try {
    const res = await api.get('/api/industries', { params: { page: currentPage.value, size: pageSize.value } });
    industries.value = res.data.content;
    totalElements.value = res.data.totalElements;
    totalPages.value = res.data.totalPages;
  } catch {
    toast.error('Không thể tải danh sách ngành nghề');
  } finally {
    loading.value = false;
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchIndustries();
  }
};

const addIndustry = async () => {
  try {
    await api.post('/api/industries', newIndustry);
    toast.success('Thêm thành công');
    newIndustry.name = '';
    fetchIndustries();
  } catch {
    toast.error('Lỗi khi thêm ngành nghề');
  }
};

const editIndustry = (industry) => {
  Object.assign(currentIndustry, industry);
};

const updateIndustry = async () => {
  try {
    await api.put(`/api/industries/${currentIndustry.id}`, currentIndustry);
    toast.success('Cập nhật thành công');
    fetchIndustries();
  } catch {
    toast.error('Lỗi khi cập nhật');
  }
};

const confirmDelete = (id) => {
  industryToDeleteId.value = id;
};

const deleteIndustry = async () => {
  try {
    await api.delete(`/api/industries/${industryToDeleteId.value}`);
    toast.success('Xóa thành công');
    
    // Ẩn modal bằng jQuery
    $('#delete_industry_modal').modal('hide');

    fetchIndustries();
  } catch {
    toast.error('Lỗi khi xóa');
  }
};

onMounted(fetchIndustries);
</script>
